<template>
  <div class="echarts_show" id="echarts_show"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "customerChart",
  props: ["propData", "checkbox", "isSeven"],
  data() {
    return {
      echarts_data: null,
      color: [],
      val: [],
    };
  },
  methods: {
    getCharts(value) {
      this.val = [...value];

      let dateArray = [];
      let stuCnt = []; //客户总数
      let newContactCnt = []; //新增
      let negativeFeedbackCnt = []; //流失
      value.filter((item) => {
        dateArray.unshift(item.behaviorTime.split(" ")[0]);
        stuCnt.unshift(item.stuCnt);
        newContactCnt.unshift(item.newContactCnt);
        negativeFeedbackCnt.unshift(item.negativeFeedbackCnt);
      });
      if (!this.echarts_data) {
        this.echarts_data = echarts.init(
          document.getElementById("echarts_show")
        );
      }
      let series = [];
      this.color = [];
      if (this.checkbox.includes("customerTotal")) {
        series.push({
          name: "客户总数",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          lineStyle: {
            width: 2,
          },
          data: stuCnt,
        });
        this.color.push("#277FFF");
      }
      if (this.checkbox.includes("addCustomer")) {
        series.push({
          name: "新增客户数",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          lineStyle: {
            width: 2,
          },
          data: newContactCnt,
        });
        this.color.push("#11C690");
      }
      if (this.checkbox.includes("loseCustomer")) {
        series.push({
          name: "流失客户数",
          type: "line",
          symbol: "circle",
          symbolSize: 5,
          lineStyle: {
            width: 2,
          },
          data: negativeFeedbackCnt,
        });
        this.color.push("#F6B600");
      }

      let option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "30px",
          left: "0px",
          right: "20px",
          bottom: "4px",
          containLabel: true,
        },
        color: this.color,
        xAxis: {
          type: "category",
          data: dateArray,
          axisLabel: {
            fontSize: 10,
            color: "#666666",
            margin: 15,
            // interval:interval,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#D0D0D0",
            },
          },
          splitLine: {
            show: false, // 不显示网格线
          },
        },
        dataZoom: [
          {
            type: "inside",
            endValue: 9,
            zoomLock: true, //禁止双指缩放
          },
        ],
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
          axisLabel: {
            fontSize: 10,
            color: "#333333",
          },
        },
        series: series,
      };
      this.echarts_data.clear();
      this.echarts_data.setOption(option);
    },
  },
  watch: {
    propData: {
      handler(val) {
        if (!val) {
          val = [];
        }
        this.getCharts(val);
      },
      deep: true,
    },
    checkbox: {
      handler() {
        this.getCharts(this.val);
      },
      deep: true,
    },
  },
};
</script>

<style lang="less"></style>
